export default __webpack_public_path__ + "static/media/profile.4f3785e9.svg";